export default __webpack_public_path__ + "static/media/Rectangle325.a60b69b0.svg";